export default __webpack_public_path__ + "static/media/ic_slt_storage.c3389e2d.jpg";